



import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import SpacePage from '@/renderer/components/SpacePage/list.vue';
export default defineComponent({
  components: {
    SpacePage,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { query } = vm.$route;
    const spaceId = query.spaceId as string;
    const id = +query.id;
    const name = query.name as string;
    return {
      spaceId,
      id,
      name,
    };
  },
});
